import apiClient from './apiClient';

const DiaryService = {
    addEntry: async (data) => {
        const formData = new FormData();
        formData.append('user_id', data.user_id);
        formData.append('testo', data.testo);
        if (data.date) formData.append('date', data.date);
        if (data.start_time) formData.append('start_time', data.start_time);
        if (data.end_time) formData.append('end_time', data.end_time);
        formData.append('entry_type', data.entry_type || 'descrizione');
        if (data.shift_period) formData.append('shift_period', data.shift_period);
        if (data.guest_id !== undefined) formData.append('guest_id', data.guest_id === null ? '' : data.guest_id);
        if (data.notes) formData.append('notes', JSON.stringify(data.notes));

        if (data.files && data.files.length) {
            for (let i = 0; i < data.files.length; i++) {
                formData.append('files[]', data.files[i]);
            }
        }

        try {
            const response = await apiClient.post('/diario.php?action=add', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            if (!response.data || !response.data.success) {
                throw new Error(response.data?.error || 'Errore durante l\'inserimento del diario');
            }

            return response.data;
        } catch (err) {
            if (err.response && err.response.data) {
                const serverMsg = err.response.data.error || JSON.stringify(err.response.data);
                throw new Error(serverMsg);
            }
            throw err;
        }
    },

    addAppointment: async (data) => {
        return DiaryService.addEntry(data);
    },

    getAllEntries: async () => {
        const response = await apiClient.get('/diario.php?action=getAll');
        return response.data;
    },

    getEntriesByDate: async (date) => {
        const d = new Date(date);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        const day = `${yyyy}-${mm}-${dd}`;
        const response = await apiClient.get(`/diario.php?action=getByDate&date=${day}`);
        const data = response.data;
        if (data && Array.isArray(data.entries)) return data;
        return { entries: Array.isArray(data) ? data : [], sick_collaborators: [], injured_collaborators: [] };
    },

    getNotesByGuest: async (guestId, months = null) => {
        if (!guestId) throw new Error('guestId richiesto');
        let url = `/diario.php?action=getByGuest&guest_id=${guestId}`;
        if (months && Number.isInteger(months) && months > 0) {
            url += `&months=${months}`;
        }
        const response = await apiClient.get(url);
        return response.data;
    },

    updateEntry: async (data) => {
        const formData = new FormData();
        formData.append('id', data.id);
        if (data.user_id !== undefined) formData.append('user_id', data.user_id);
        if (data.testo !== undefined) formData.append('testo', data.testo);
        if (data.start_time !== undefined) formData.append('start_time', data.start_time);
        if (data.end_time !== undefined) formData.append('end_time', data.end_time);
        if (data.guest_id !== undefined) formData.append('guest_id', data.guest_id === null ? '' : data.guest_id);
        if (data.entry_type !== undefined) formData.append('entry_type', data.entry_type);
        if (data.notes !== undefined) formData.append('notes', JSON.stringify(data.notes));

        const response = await apiClient.post('/diario.php?action=update', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    },

    updateDescription: async (data) => {
        const form = new FormData();
        form.append('id', data.id);
        form.append('testo', data.testo);
        const response = await apiClient.post('/diario.php?action=updateDescription', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response.data;
    },

    updateNote: async (data) => {
        const form = new FormData();
        form.append('note_id', data.note_id);
        if (data.azione !== undefined) form.append('azione', data.azione);
        if (data.start_orario !== undefined) form.append('start_orario', data.start_orario);
        if (data.end_orario !== undefined) form.append('end_orario', data.end_orario);
        if (data.guest_id !== undefined) form.append('guest_id', data.guest_id === null ? 0 : data.guest_id);
        const response = await apiClient.post('/diario.php?action=updateNote', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response.data;
    },

    deleteNote: async (noteId) => {
        const form = new FormData();
        form.append('note_id', noteId);
        const response = await apiClient.post('/diario.php?action=deleteNote', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response.data;
    },

    deleteDescription: async (id) => {
        const form = new FormData();
        form.append('id', id);
        const response = await apiClient.post('/diario.php?action=deleteDescription', form, { headers: { 'Content-Type': 'multipart/form-data' } });
        return response.data;
    },

    deleteEntry: async (id) => {
        const form = new FormData();
        form.append('id', id);
        const response = await apiClient.post('/diario.php?action=delete', form, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }
};

export default DiaryService;
